// components/BusinessCategoryTable.js
import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchCategoryAnalytics } from "../slices/categoryAnalyticsSlice";
import { ShimmerTable } from "shimmer-effects-react";

const BusinessCategoryTable = () => {
  const [selectedTab, setSelectedTab] = useState("Monthly");
  const dispatch = useDispatch();
  const { data, status } = useSelector((state) => state.categoryAnalytics);

  useEffect(() => {
    dispatch(fetchCategoryAnalytics(selectedTab.toLowerCase())); // Fetch data based on selected tab
  }, [selectedTab, dispatch]);

  const handleTabClick = (tab) => {
    setSelectedTab(tab);
  };

  return (
    <div className="bg-secondary p-6 rounded-lg shadow-lg">
      <div className="flex justify-start items-center mb-4 gap-3">
        {["All", "Weekly", "Monthly", "Yearly"].map((tab) => (
          <button
            key={tab}
            className={`tab-button ${selectedTab === tab && "tab-button-active"
              }`}
            onClick={() => handleTabClick(tab)}
          >
            {tab}
          </button>
        ))}
      </div>
      {status === "loading" ? (
        <div className="p-5">
          <div>Loading...</div>
          <ShimmerTable mode="dark" row={7} col={3} border={0} borderColor={"#cbd5e1"} rounded={0.25} rowGap={16} colPadding={[10, 5, 10, 5]} />
        </div>
      ) : (
        <div className="overflow-hidden">
          <table className="min-w-full bg-secondary">
            <thead>
              <tr className="bg-accent-dark text-white">
                <th className="py-3 px-4 text-left">Business Category</th>
                <th className="py-3 px-4 text-left">Total Vendors</th>
                <th className="py-3 px-4 text-left">Turnover</th>
              </tr>
            </thead>
            <tbody className="overflow-y-auto">
              {data.map((item, index) => (
                <tr
                  key={index}
                  className={`${index % 2 === 0 ? "bg-secondary-light" : "bg-secondary"
                    } text-white`}
                >
                  <td className="py-3 px-4">{item._id}</td>
                  <td className="py-3 px-4">{item.totalVendors}</td>
                  <td className="py-3 px-4">{item.totalEarnings}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

export default BusinessCategoryTable;
